import { render, staticRenderFns } from "./UrnStockMovement.vue?vue&type=template&id=05a71ed8&scoped=true&"
import script from "./UrnStockMovement.vue?vue&type=script&lang=js&"
export * from "./UrnStockMovement.vue?vue&type=script&lang=js&"
import style0 from "./UrnStockMovement.vue?vue&type=style&index=0&id=05a71ed8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a71ed8",
  null
  
)

export default component.exports